module.exports = __webpack_public_path__ + "static/style-guide-4dc16d15fdefe86d074028629b9fe2a8.jpg";